import * as React from 'react'
import FormGroup from '@mui/material/FormGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox, { CheckboxProps } from '@mui/material/Checkbox'
import { SxProps } from '@mui/material'

type CheckboxLabelProps = {
	checkboxProps?: CheckboxProps
	label: React.ReactNode | 'string'
	sx?: SxProps
}

export default function CheckboxLabel({ checkboxProps, label, sx }: CheckboxLabelProps) {
	return (
		<FormGroup>
			<FormControlLabel control={<Checkbox {...checkboxProps} />} label={label} sx={sx} />
		</FormGroup>
	)
}
